import { hotelsApi as coreHotelsApi } from "@b2bportal/core-utilities";
import type { ShopRequest } from "@b2bportal/lodging-api";
import type { RawAxiosRequestConfig } from "axios";
import { withFintechFunnelIdHeader } from "../fintechFunnelId";

/**
 * The core lodging API, with the current lodging funnel ID added to the shop
 * request.
 *
 * A funnel ID is the UUID the frontend generates for one shopping funnel — a
 * single continuous shop within one vertical, rotated whenever the traveller
 * commits a materially different search or switches vertical — and fintech
 * needs it because it groups the offers a traveller was shown and the
 * transaction they eventually booked by funnel rather than by the authenticated
 * session, which can span several unrelated searches.
 *
 * Shop is the request that returns the CFAR offers, so the BFF needs the funnel
 * ID there to attribute those offers to the same funnel the frontend reports
 * everywhere else (RBC-2353, paired with rbc-bff RBC-2352).
 *
 * The header is added here rather than at the call site because shop is issued
 * from shared `core-hotels` code (`fetchHotelsShop`) and only the RBC BFF reads
 * the header.
 */
export const hotelsApi: typeof coreHotelsApi = {
  ...coreHotelsApi,
  apiV0HotelsShopPost: (
    shopRequest: ShopRequest,
    options?: RawAxiosRequestConfig
  ) =>
    coreHotelsApi.apiV0HotelsShopPost(
      shopRequest,
      withFintechFunnelIdHeader("lodging", options)
    ),
};
